import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../API/api';
// Initially we will have a light mode
const initialState = {
    isLoading: true,
    list: [],
    status: 'loading',
    error: null
};

// Handle our action of changing the theme

export const ExamsFetchApi = createAsyncThunk('ExamsFetchReducer/ExamsFetchApi', async () => {
    const response = await api.getExamType()
    console.log(response, 'getExamType values');
    return response.data.examtype;
})

export const ExamsFetchReducer = createSlice({
    name: 'ExamsFetch',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(ExamsFetchApi.pending, (state, action) => {
                state.status = 'loading'
                state.isLoading = true
                console.log(initialState, 'initialState');
            })
            .addCase(ExamsFetchApi.fulfilled, (state, action) => {
                state.status = 'succeeded'
                state.list = action.payload
                state.isLoading = false
                console.log(action, 'action.payload question');
            })
            .addCase(ExamsFetchApi.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.payload
                state.isLoading = false
                console.log(JSON.stringify(state),action, 'faisled');
            })
    }
})

export default ExamsFetchReducer.reducer;